import { RestApiProxy } from 'com-gyf-webcore-servicehub';

let GetApiUrlsHelper = function () {
    function _getAxiosUrl(endpoint) {
        let conciergeApiUrl = RestApiProxy.GetApiUrl('Concierge');
        conciergeApiUrl = conciergeApiUrl.substring(0, conciergeApiUrl.indexOf("/Concierge/"));

        let url = conciergeApiUrl + "/ExportFiles/api/" + endpoint;

       // Modificar esta línea si se está probando local con la url que corresponda
    // url = 'http://localhost:5226/api/' + endpoint;

        return url;
    }

    return {
        GetAxiosUrl: function (endpoint) {
            return _getAxiosUrl(endpoint);
        }
    }
}

let getApiUrlsHelper = new GetApiUrlsHelper();
export default getApiUrlsHelper;